export const CONVERSATION_RETRIEVE_REQUESTED = 'CONVERSATION_RETRIEVE_REQUESTED';
export const CONVERSATION_RETRIEVE_SUCCEED = 'CONVERSATION_RETRIEVE_SUCCEED';
export const CONVERSATION_RETRIEVE_FAILED = 'CONVERSATION_RETRIEVE_FAILED';

export const CONVERSATION_RETRIEVE_SEARCH_REQUESTED = 'CONVERSATION_RETRIEVE_SEARCH_REQUESTED';
export const CONVERSATION_RETRIEVE_SEARCH_SUCCEED = 'CONVERSATION_RETRIEVE_SEARCH_SUCCEED';
export const CONVERSATION_RETRIEVE_SEARCH_FAILED = 'CONVERSATION_RETRIEVE_SEARCH_FAILED';

export const CONVERSATIONS_RETRIEVE_REQUESTED = 'CONVERSATIONS_RETRIEVE_REQUESTED';
export const CONVERSATIONS_RETRIEVE_SUCCEED = 'CONVERSATIONS_RETRIEVE_SUCCEED';
export const CONVERSATIONS_RETRIEVE_FAILED = 'CONVERSATIONS_RETRIEVE_FAILED';

export const CONVERSATIONS_INIT_REQUESTED = 'CONVERSATIONS_INIT_REQUESTED';
export const CONVERSATIONS_INIT_SUCCEED = 'CONVERSATIONS_INIT_SUCCEED';
export const CONVERSATIONS_INIT_FAILED = 'CONVERSATIONS_INIT_FAILED';

export const DOCTOR_CONVERSATIONS_PENDING_REQUESTED = 'DOCTOR_CONVERSATIONS_PENDING_REQUESTED';
export const DOCTOR_CONVERSATIONS_PENDING_SUCCEED = 'DOCTOR_CONVERSATIONS_PENDING_SUCCEED';
export const DOCTOR_CONVERSATIONS_PENDING_FAILED = 'DOCTOR_CONVERSATIONS_PENDING_FAILED';

export const CONVERSATIONS_CLEAR = 'CONVERSATIONS_CLEAR';

export const CONVERSATION_REMOVE_BY_ID = 'CONVERSATION_REMOVE_BY_ID';

export const CONVERSATION_ADD_BY_ID = 'CONVERSATION_ADD_BY_ID';

export const CONVERSATIONS_ENTITIES_UPDATE = 'CONVERSATIONS_ENTITIES_UPDATE';
